<ng-container *ngIf="translations">
  <app-account-portal-v2 [translations]="translations"></app-account-portal-v2>
</ng-container>
